"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_small__and__lightweight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dfcdc5af-c630-46d4-8873-267548deae0d",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "small-and-lightweight-mid"), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,21.51",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 192,
    height: 192,
    transform: "translate(192 192.5) rotate(180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.93,82.5C93.25,79.73,123.86,69.69,140,34.16c4.48-9.86,10.33-13.67,16.67-13.66,0,0,15.33-1,15.33,33,0,22.3-10.8,76.79-73.8,101.79",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,109.5a172.49,172.49,0,0,0,20.24-41",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.69,
    y1: 121.28,
    x2: 60,
    y2: 82.97,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,168.5c-40-13-52.31-46.72-52.31-46.72",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,159.48C94.51,160.16,64,141,64,141",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.77,119.12c20.14,5.14,99.61,20,129-56.62",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_small__and__lightweight;
exports.default = _default;